/**
 * Firebase Console → Project settings → Your apps → Web app config.
 * Bu değerleri doldurun; üretimde env veya gizli CI değişkenleri kullanın.
 */
export const firebaseConfig = {
  apiKey: 'AIzaSyCC-5qTntQNueiRrQNeDd07t25bIWyK5gs',
  authDomain: 'annedas-c79e9.firebaseapp.com',
  projectId: 'annedas-c79e9',
  storageBucket: 'annedas-c79e9.firebasestorage.app',
  messagingSenderId: '410228076402',
  appId: '1:410228076402:web:d0b8d0c2fe1c90ce8637eb',
};
